/**
 * Editor preview block chrome (hover + selection outlines).
 * Warm orange reads clearly on light popup backgrounds (OptiMonk-style).
 */
export const PREVIEW_BLOCK_HIGHLIGHT = {
  hoverOutline: "1px solid rgba(234, 88, 12, 0.5)",
  hoverOutlineOffset: "0px",
  selectedOutline: "1px solid #ea580c",
  selectedOutlineOffset: "0px",
  selectedBorder: "1px solid #ea580c",
  hoverFill: "rgba(251, 146, 60, 0.06)",
  shellGuideBorderColor: "rgba(234, 88, 12, 0.35)",
  shellGuideLabelBg: "#ea580c",
};

export function getPreviewBlockOutlineStyle({ isSelected, isHovered, isPreviewMode }) {
  if (!isPreviewMode) {
    return { outline: "none", outlineOffset: "0" };
  }
  if (isSelected) {
    return {
      outline: PREVIEW_BLOCK_HIGHLIGHT.selectedOutline,
      outlineOffset: PREVIEW_BLOCK_HIGHLIGHT.selectedOutlineOffset,
    };
  }
  if (isHovered) {
    return {
      outline: PREVIEW_BLOCK_HIGHLIGHT.hoverOutline,
      outlineOffset: PREVIEW_BLOCK_HIGHLIGHT.hoverOutlineOffset,
    };
  }
  return { outline: "none", outlineOffset: "0" };
}
